import Header from '../_patterns/01-components/header/header';
import Navigation from '../_patterns/01-components/navigation/navigation';
import CartFlyout from '../_patterns/01-components/cart-flyout/cart-flyout';
import TopBannerCarousel from '../_patterns/01-components/top-banner-carousel/top-banner-carousel';
import CorporateGiftsBar from '../_patterns/01-components/corporate-gifts-bar/corporate-gifts-bar';
import BenefitsBar from '../_patterns/01-components/benefits-bar/benefits-bar';
import CountryNavDialog from '../_patterns/01-components/country-nav-selector/country-nav-selector';
import SwaCountryFeedbackDialog from '../_patterns/01-components/country-nav-feedback-dialog/country-nav-feedback-dialog';
import GlobalMessage from '../_patterns/00-atoms/global-message/global-message';
import SearchLayer from '../_patterns/01-components/search-layer/search-layer';
import CmsCountdown from '../_patterns/01-components/cms-components/cms-countdown';
import SwaDialogOverlay from '../_patterns/01-components/dialog-overlay/dialog-overlay';

import {
  detectMobile,
  debounceEvent,
  renderOutline,
  showHideSkipLinks,
  addPaddingOnTeaserContent,
} from './utils';

const stickyHeaderObserver = () => {
  const mainNavigationHeight = 39;
  let currentHeaderHeight = document.querySelector('header').offsetHeight;
  const allPagesNewHeader = document.querySelector('.swa-all-pages-new-header');
  const mainPage = document.querySelector('#swa-main');//remove this line and all related code after the navigation uniformization goes live and oldMainPage is removed
  const oldMainPage = document.querySelector('#main');//remove this line and all related code after the navigation uniformization goes live and oldMainPage is removed
  const transparentHeader = document.querySelector('.js-swa-header-transparent');
  let stickyHeaderPositionTriggerLarge;
  const cartFlyout = document.querySelector('.swa-header__cart-flyout');
  const swaHeader = document.querySelector('.swa-header');
  if (transparentHeader) {
    stickyHeaderPositionTriggerLarge = 50;
  }
  else {
    stickyHeaderPositionTriggerLarge = document.querySelector('header').offsetHeight - mainNavigationHeight;
  }
  let stickyHeaderPositionTriggerSmall = 5;
  const logoImage = document.querySelector(
    '.swa-header__compressed .swa-link__image--logo-mobile--default'
  );
  let logoImageHover = '';
  let logoImageSrc = '';

  //For small header logo variation on desktop
  const logoImageSmall = document.querySelector('.swa-link__image--logo--transparent--small');
  let logoImageSmallSrc = '';
  let logoImageSmallHover = '';

  //For small header logo variation on mobile/tablet
  const logoImageSmallMobile = document.querySelector('.swa-header__compressed-logo--show');

  if (logoImage) {
    logoImageSrc = logoImage.getAttribute('src');
    if (logoImage.dataset.hover) {
      logoImageHover = logoImage.dataset.hover;
    }
  }

  if (logoImageSmall) {
    logoImageSmallHover = logoImageSmall.dataset.hover;
    logoImageSmallSrc = logoImageSmall.getAttribute('src');
  }

  let updatedScrollPosition = window.pageYOffset;
  let ticking = false;
  let isCurrentlySticky = false;

  //Calculate cart flyout max height at init, before the user starts scrolling (in case it opens the flyout at that point)
  calculateCartFlyoutMaxHeight(cartFlyout, swaHeader);

  window.addEventListener('scroll', function (e) {
    const hiddenCart = document.querySelector('.swa-hidden-cart');
    const mobileMainNavigationActive = document.querySelector(
      '.js-swa-main-navigation .swa-main-navigation--sm-opened'
    );
    const desktopMainNavigationActive = document.querySelector(
      '.swa-main-navigation__menu-item .swa-active'
    );

    let openedMenu = document.querySelector('.swa-main-navigation__level1>.swa-active') ? true : false;
    let dialogOpenElement = document.querySelector('.swa-dialog-open');
    const isDisabledScroll = document.getElementById('swa-main')?.getAttribute("data-disable-scroll") === 'true';

    updatedScrollPosition = window.pageYOffset;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        let stickyTriggerPosition = detectMobile() ?
          stickyHeaderPositionTriggerSmall :
          stickyHeaderPositionTriggerLarge;
        if (
          isCurrentlySticky &&
          updatedScrollPosition < stickyTriggerPosition &&
          (!detectMobile() || (hiddenCart && detectMobile()))
        ) {
          // Keep the sticky header class for other header elements to not push the content up when dialog is opened
          if (swaHeader.classList.contains('swa-header--sticky') && !dialogOpenElement) {
            swaHeader.classList.remove('swa-header--sticky');
            if (transparentHeader && updatedScrollPosition !== 0) {
              const middleSlot = swaHeader.querySelector('.swa-header__middle-slot');
              const compressedLogoTransparent = swaHeader.querySelector('.swa-header__compressed-logo-transparent .swa-link__image');
              middleSlot.classList.add('swa-header__middle-slot--transition');
              if (compressedLogoTransparent) {
                compressedLogoTransparent.classList.add('swa-link__image--transition');
              }
            }

            if (!detectMobile()) {
              currentHeaderHeight = document.querySelector('header').offsetHeight;
            }

            if (!transparentHeader) {
              if (mainPage && !allPagesNewHeader) {
                mainPage.setAttribute('style', 'padding-top: 0');
              }

              if (oldMainPage) {
                oldMainPage.setAttribute('style', 'padding-top: 0');
              }
            }
          }

          isCurrentlySticky = false;
          const asmHeader = document.querySelector('.js-swa-asm-header');

          // if Header is transparent and not sticky
          if (!asmHeader) {
            if (transparentHeader && isCurrentlySticky === false) {
              if (detectMobile()) {
                if (!mobileMainNavigationActive) {
                  addTransparent();
                  if (logoImage) {
                    logoImage.src = logoImageSrc;
                  }
                } else if (mobileMainNavigationActive) {
                  addSolid();
                  if (logoImage) {
                    logoImage.src = logoImageHover;
                  }
                }
              } else {
                if (!desktopMainNavigationActive && hiddenCart) {
                  // For desktop - If navigation layers are HIDDEN, add transparent
                  addTransparent();

                  if (logoImageSmall) {
                    logoImageSmall.src = logoImageSmallSrc;
                  }
                } else {
                  // For desktop - If any navigation layer is ACTIVE, add solid
                  addSolid();

                  if (logoImageSmall) {
                    logoImageSmall.src = logoImageSmallHover;
                  }
                }
              }
              // On desktop, add hover
              transparentHeaderHover();
            }
          }
        } else if (!isCurrentlySticky && updatedScrollPosition > stickyTriggerPosition && !openedMenu && !isDisabledScroll) {
          document.querySelector('.swa-header').classList.add('swa-header--sticky');
          //Calculate cart flyout max height when header is sticky
          calculateCartFlyoutMaxHeight(cartFlyout, swaHeader);

          if (transparentHeader) {
            const middleSlot = swaHeader.querySelector('.swa-header__middle-slot');
            const compressedLogoTransparent = swaHeader.querySelector('.swa-header__compressed-logo-transparent .swa-link__image');
            middleSlot.classList.add('swa-header__middle-slot--transition');
            if (compressedLogoTransparent) {
              compressedLogoTransparent.classList.add('swa-link__image--transition');
            }
          }

          if (!transparentHeader && mainPage && !allPagesNewHeader) {
            if (detectMobile()) {
              mainPage.setAttribute('style', 'padding-top:' + swaHeader.offsetHeight + 'px');
            }
            else {
              mainPage.setAttribute('style', 'padding-top:' + currentHeaderHeight + 'px');
            }
          }

          if (!transparentHeader && oldMainPage) {
            if (detectMobile()) {
              oldMainPage.setAttribute('style', 'padding-top:' + swaHeader.offsetHeight + 'px');
            }
            else {
              oldMainPage.setAttribute('style', 'padding-top:' + currentHeaderHeight + 'px');
            }
          }

          isCurrentlySticky = true;
          // On mobile, remove hover
          removeHeaderHoverMobile();

          // If Header is transparent and sticky
          if (transparentHeader && isCurrentlySticky === true) {
            // Add small dark logo, remove the transparent class and add the solid class
            if (logoImage && logoImageHover) {
              logoImage.src = logoImageHover;
            }

            // If the small logo header variation, preset the white logo for mobile/tablet when desktop header sticky
            if (logoImageSmallMobile && !detectMobile()) {
              logoImage.src = logoImageSrc;
            }

            // If the small logo header variation, add the black logo on mobile/tablet when sticky  header mobile/tablet
            if (logoImageSmallMobile && detectMobile()) {
              logoImage.src = logoImageHover;
            }

            transparentHeader.classList.remove('swa-header--transparent');
            if (!transparentHeader.classList.contains('swa-header--solid')) {
              addSolid();
            }
          }
        } else if (!isCurrentlySticky && updatedScrollPosition < stickyTriggerPosition && !openedMenu) {
          //Calculate cart flyout max height when header not sticky
          calculateCartFlyoutMaxHeight(cartFlyout, swaHeader);

          const plpTopTeaserContent = document.querySelector('.js-swa-plp-top-teaser-content');
          const accountTopTeaserContent = document.querySelector('.js-account-top-teaser-content');

          if (transparentHeader) {
            // when header not sticky => add padding on top teaser if plpTopTeaser/accountTopTeaser exists & if header is transparent
            if (plpTopTeaserContent) {
              addPaddingOnTeaserContent(plpTopTeaserContent);
            }
            else if (accountTopTeaserContent) {
              addPaddingOnTeaserContent(accountTopTeaserContent);
            }
          }
        }

        ticking = false;
      });

      ticking = true;
    }
  });

  window.addEventListener('resize', debounceEvent((e) => {
    if (!document.querySelector('header').classList.contains('swa-header--sticky')) {
      if (!detectMobile()) {
        currentHeaderHeight = document.querySelector('header').offsetHeight;
      }
      if (transparentHeader) {
        stickyHeaderPositionTriggerLarge = 50;
      }
      else {
        stickyHeaderPositionTriggerLarge = document.querySelector('header').offsetHeight - mainNavigationHeight;
      }

      //Make sure the logos will be the same after resize;
      if (logoImageSmall && !detectMobile() && transparentHeader.classList.contains('swa-header--transparent')) {
        logoImageSmall.src = logoImageSmallSrc;
      }

      if (transparentHeader) {
        if (logoImageSmallMobile && detectMobile()) {
          logoImage.src = logoImageSrc;
        }

        if (document.querySelector('header').classList.contains('swa-header--sticky')) {
          if (logoImageSmallMobile && detectMobile()) {
            logoImage.src = logoImageHover;
          }
        }
      }
    }
    else {
      if (detectMobile() && !transparentHeader) {
        if (oldMainPage) {
          oldMainPage.setAttribute('style', 'padding-top:' + document.querySelector('header').offsetHeight + 'px');
        }
        if (mainPage && !allPagesNewHeader) {
          mainPage.setAttribute('style', 'padding-top:' + document.querySelector('header').offsetHeight + 'px');
        }
      }
      else if (!detectMobile() && !transparentHeader) {
        if (oldMainPage) {
          oldMainPage.setAttribute('style', 'padding-top:' + currentHeaderHeight + 'px');
        }
        if (mainPage && !allPagesNewHeader) {
          mainPage.setAttribute('style', 'padding-top:' + currentHeaderHeight + 'px');
        }
      }
    }
    },
    250));

  setTimeout(function () {
    window.dispatchEvent(new Event('resize'))
  }, 100);

  if (updatedScrollPosition > (detectMobile() ? stickyHeaderPositionTriggerSmall : stickyHeaderPositionTriggerLarge)) {
    document.querySelector('.swa-header').classList.add('swa-header--sticky');
    isCurrentlySticky = true;

    // if Header is transparent and sticky
    if (transparentHeader && isCurrentlySticky === true) {
      // remove the transparent class and add the solid class
      transparentHeader.classList.remove('swa-header--transparent');
      transparentHeader.classList.add('swa-header--solid');
      if (logoImage && logoImageHover) {
        logoImage.src = logoImageHover;
      }

      transparentHeader.addEventListener('mouseleave', () => {
        // on mouse leave, the header needs to remain solid
        transparentHeader.classList.remove('swa-header--transparent');
        transparentHeader.classList.add('swa-header--solid');
      });
    }
  }
};

// Handle logo for transparent header
const handleLogo = () => {
  const swaHeader = document.querySelector('.swa-header');
  const logoImageSmall = document.querySelector('.swa-link__image--logo--transparent--small');
  const transparentHeader = document.querySelector('.js-swa-header-transparent');
  const searchContainer = document.querySelector('.swa-header__flyout-container');

  let logoImageSmallSrc = '';
  let logoImageSmallHover = '';
  let isSticky;

  if (transparentHeader) {
    if (logoImageSmall) {
      logoImageSmallSrc = logoImageSmall.getAttribute('src');
      logoImageSmallHover = logoImageSmall.dataset.hover;
    }

    transparentHeader.addEventListener('mouseenter', () => {
      isSticky = swaHeader.classList.contains('swa-header--sticky');

      if (logoImageSmall && !detectMobile() && !isSticky) {
        logoImageSmall.src = logoImageSmallHover;
      }
    });

    transparentHeader.addEventListener('mouseleave', () => {
      isSticky = swaHeader.classList.contains('swa-header--sticky');

      if (logoImageSmall && !detectMobile() && !isSticky) {
        // If the search flyout is still open, we need the dark small logo
        if (searchContainer.classList.contains('swa-header__flyout-container--search')) {
          logoImageSmall.src = logoImageSmallHover;
        } else {
          logoImageSmall.src = logoImageSmallSrc;

          if (swaHeader.classList.contains('swa-header--transparent-solid-focus')) {
            swaHeader.classList.remove('swa-header--transparent-solid-focus');
          }
        }
      }
    });
  }
};

// In case of transparent header - on desktop we need the hover function
const transparentHeaderHover = () => {
  const transparentHeader = document.querySelector('.js-swa-header-transparent');
  const searchContainer = document.querySelector('.swa-header__flyout-container');
  const asmHeader = document.querySelector('.js-swa-asm-header');
  let viewport = '';
  viewport = detectMobile() ? 'mobile' : 'desktop';

  if (transparentHeader && !asmHeader) {
    if (viewport === 'desktop') {
      transparentHeader.addEventListener('mouseenter', addSolid);
      transparentHeader.addEventListener('mouseleave', () => {
        //  Prevent the header of becoming transparent if the search flyout is still open
        if (searchContainer.classList.contains('swa-header__flyout-container--search')) {
          addSolid();
        } else {
          addTransparent();
        }
      });
    }
  } else {
    return;
  }
};

const addSolid = () => {
  const transparentHeader = document.querySelector('.js-swa-header-transparent');
  // for desktop, on mouse enter, the header should be solid
  transparentHeader.classList.remove('swa-header--transparent');
  transparentHeader.classList.add('swa-header--solid');
};

const addTransparent = () => {
  const transparentHeader = document.querySelector('.js-swa-header-transparent');
  const isCurrentlySticky = document.querySelector('.swa-header--sticky');

  // The sticky header is always solid!
  if (isCurrentlySticky) {
    return;
  }

  // On mouse leave, the header should be transparent
  transparentHeader.classList.remove('swa-header--solid');
  transparentHeader.classList.add('swa-header--transparent');
};

// In case of transparent header, for mobile, remove listeners
const removeHeaderHoverMobile = () => {
  const transparentHeader = document.querySelector('.js-swa-header-transparent');

  if (transparentHeader) {
    transparentHeader.removeEventListener('mouseenter', addSolid);
    transparentHeader.removeEventListener('mouseleave', addTransparent);
  }
};

const addWindowResizeListener = () => {
  const transparentHeader = document.querySelector('.js-swa-header-transparent');
  let isMobile = detectMobile();

  if (transparentHeader) {
    window.addEventListener(
      'resize',
      debounceEvent(() => {
        let currentIsMobile = detectMobile();
        if (isMobile != currentIsMobile && isMobile) {
          isMobile = !isMobile;
          transparentHeaderHover();
        } else if (isMobile != currentIsMobile && !isMobile) {
          isMobile = !isMobile;
          removeHeaderHoverMobile();
        }

        const hiddenCart = document.querySelector('.swa-hidden-cart');

        if (!hiddenCart && !currentIsMobile) {
          const mainNavigationHeight = 39;
          let stickyHeaderPositionTrigger;
          if (transparentHeader) {
            stickyHeaderPositionTrigger = 50;
          }
          else {
            stickyHeaderPositionTrigger = 175 - mainNavigationHeight;
          }
          let updatedScrollPosition = 0;

          updatedScrollPosition = window.pageYOffset;

          if (updatedScrollPosition < stickyHeaderPositionTrigger) {
            const header = document.querySelector('.swa-header');
            header.classList.remove('swa-header--sticky');
            header.classList.add('swa-header--solid');
          }
        }
      }, 250)
    );
  }
};

const calculateTeaserPosition = (teaserElement) => {
  const transparentHeader = document.querySelector(
    '.js-swa-header-transparent'
  );
  const contentTeaserSlides = teaserElement.querySelectorAll(
    '.js-swa-teaser-carousel-content'
  );
  const teaserCarousel = document.querySelector('.js-swa-teaser-carousel, .js-swa-splide-teaser-carousel');
  let headerHeight;
  let teaserArrows;
  let spaceLeftForTeaserContent;
  let teaserHeight;

  if (teaserCarousel) {
    teaserArrows = teaserCarousel.querySelectorAll('.glide__arrow, .splide__arrow');
    teaserHeight = teaserCarousel.offsetHeight;
  }

  if (contentTeaserSlides && transparentHeader) {
    if (detectMobile()) {
      headerHeight = transparentHeader.offsetHeight - 20;
    } else {
      headerHeight = transparentHeader.offsetHeight - 10;
    }

    if (teaserCarousel) {
      spaceLeftForTeaserContent = teaserHeight - headerHeight;
    }

    if (teaserArrows) {
      teaserArrows.forEach(arrow => {
        arrow.style.top = (headerHeight + (spaceLeftForTeaserContent - arrow.offsetHeight) / 2) + 'px';
        arrow.classList.add('teaser-fade-in');
      });
    }

    contentTeaserSlides.forEach(contentTeaser => {
      contentTeaser.style.height = 'auto';

      const contentTeaserHeight = contentTeaser.offsetHeight;

      if (spaceLeftForTeaserContent < contentTeaserHeight) {
        contentTeaser.style.top = (headerHeight + 10) + 'px !important';
      } else {
        contentTeaser.style.top = (headerHeight + (spaceLeftForTeaserContent - contentTeaserHeight) / 2) + 'px';
      }

      // This class was added so that after the header position is calculated, the element fades in - which prevents
      // the teaser from appearing on screen and then "jumping" to its final position
      contentTeaser.classList.add('teaser-fade-in');
    });
  } else if (contentTeaserSlides && !transparentHeader) {
    // Add the same class in the case if the header is not transparent - if we do not do this, then on pages that do
    // not have the transparent header (such as the sales page), the teaser carousel remains hidden
    contentTeaserSlides.forEach(contentTeaser => {
      contentTeaser.classList.add('teaser-fade-in');
    });

    if (teaserArrows) {
      teaserArrows.forEach(arrow => {
        arrow.classList.add('teaser-fade-in');
      });
    }
  }
};

const calculateCartFlyoutMaxHeight = (cartFlyout,swaHeader) => {
  if (!document.querySelector("body").classList.contains('swa-no-scroll') && swaHeader.classList.contains('swa-header--sticky') && window.innerWidth >= 1025) {
    cartFlyout.style.maxHeight = `${window.innerHeight - swaHeader.clientHeight}px`;
  }

  if (!document.querySelector("body").classList.contains('swa-no-scroll') && !swaHeader.classList.contains('swa-header--sticky') && window.innerWidth >= 1025) {
    //in case of no sticky header, we have to calculate flyout max height taking into consideration how many pixels were already scrolled, in order to keep the height until the bottom of the screen;
    cartFlyout.style.maxHeight = `${window.innerHeight - swaHeader.clientHeight + window.pageYOffset}px`;
  }
};

const init = () => {

  const cmsCountdownElement = document.querySelector('.swa-cms-countdown');
  if (cmsCountdownElement) {
    const endTime = cmsCountdownElement.dataset.endtime;
    const countdownObj = new CmsCountdown(endTime);
    countdownObj.init();
  }
  const header = new Header();
  header.init();

  const navigation = new Navigation();
  navigation.init();

  const cartFlyout = new CartFlyout();
  cartFlyout.init();

  const searchLayer = new SearchLayer();
  searchLayer.init();

  const swaTopBannerCarouselElement = document.querySelector('.js-top-banner-carousel');
  if (swaTopBannerCarouselElement) {
    const swaTopBannerCarouselElement = new TopBannerCarousel();
    swaTopBannerCarouselElement.init();
  }

  const corporateGiftsBarObj = new CorporateGiftsBar();
  corporateGiftsBarObj.init();

  const globalMessageObj = new GlobalMessage();
  globalMessageObj.init();

  const benefitsBarElements = document.querySelectorAll('.js-swa-benefits-bar');

  benefitsBarElements.forEach(benefitElement => {
    const benefitsBarObj = new BenefitsBar();
    benefitsBarObj.init(benefitElement);
  });

  window.SwaCountryDialog = window.SwaCountryDialog || CountryNavDialog;
  window.SwaCountryFeedbackDialog = window.SwaCountryFeedbackDialog || SwaCountryFeedbackDialog;

  const countryNavDialogObj = new CountryNavDialog();
  countryNavDialogObj.init();

  const swaCountryFeedbackDialogObj = new SwaCountryFeedbackDialog();
  swaCountryFeedbackDialogObj.init();

  document
  .querySelectorAll('.js-swa-dialog')
  .forEach(dialog => {
    new SwaDialogOverlay(dialog).init();
  });

  /* add class to window object for dialogs added via ajax or cmsLinks with fragments */
  window.SwaDialogOverlayClass = window.SwaDialogOverlayClass || SwaDialogOverlay;

  const transparentHeader = document.querySelector(
    '.js-swa-header-transparent'
  );
  const asmHeader = document.querySelector('.js-swa-asm-header');

  if (asmHeader && transparentHeader) {
    transparentHeader.setAttribute("style", "position: " + 'relative' + ";");
    transparentHeader.classList.remove('swa-header--transparent');
    transparentHeader.classList.add('swa-header--solid');

    const logoImageSmall = document.querySelector('.swa-link__image--logo--transparent--small');

    if (logoImageSmall) {
      logoImageSmall.src = logoImageSmall.dataset.hover;
    }
  }

  stickyHeaderObserver();

  transparentHeaderHover();

  if (!asmHeader) {
    handleLogo();
  }

  // get the distance from the top for an element
  const getYPosition = (element) => {
    let yPosition = 0;

    while(element) {
      yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
      element = element.offsetParent;
    }

    return yPosition;
  };

  const headerBanner = document.querySelector('.js-top-banner-carousel');

  if (headerBanner) {
    headerBanner.addEventListener('click', e => {
      document
        .querySelectorAll('.js-swa-teaser-carousel, .js-swa-splide-teaser-carousel')
        .forEach(teaserElement => {
          const topTeaserYPosition = getYPosition(teaserElement);
          // calculate teaser content position only if the Top Teaser is placed on the top of the page
          if (topTeaserYPosition === 0) {
            setTimeout(() => {
              calculateTeaserPosition(teaserElement);
            }, 300); //top banner transition duration
          }
        });
    });
  }

  //Calculate teaser content at scroll, when the sticky header is not active, in order for the calculation to be done even if the page is
  // not reloaded from the top.
  const swaHeader = document.querySelector('.swa-header');
  document
    .querySelectorAll('.js-swa-teaser-carousel, .js-swa-splide-teaser-carousel')
    .forEach(teaserElement => {
      const topTeaserYPosition = getYPosition(teaserElement);
      // calculate teaser content position only if the Top Teaser is placed on the top of the page
      if (topTeaserYPosition === 0) {
        calculateTeaserPosition(teaserElement);
        window.addEventListener('scroll', debounceEvent(() => {
          const scrollY = window.pageYOffset;
          if ((!swaHeader.classList.contains('swa-header--sticky') && scrollY > 40) || (!swaHeader.classList.contains('swa-header--sticky') && scrollY < 10)) {
            calculateTeaserPosition(teaserElement);
          }
        }));

        window.addEventListener(
          'resize',
          debounceEvent(() => {
            if (!swaHeader.classList.contains('swa-header--sticky')) {
              calculateTeaserPosition(teaserElement);
            }
          }, 250)
        );
      }
      else {
        // the opacity animation class is added inside the calculateTeaserPosition function, so there is need to add it also here, when calculateTeaserPosition function is not called
        if (teaserElement) {
          if (teaserElement.classList.contains('swa-teaser-carousel-transparent-header')) {
            teaserElement.classList.add("swa-teaser-carousel--top-spacing");
          }
          const contentTeaserSlides = teaserElement.querySelectorAll(
            '.js-swa-teaser-carousel-content'
          );
          const teaserArrows = teaserElement.querySelectorAll('.glide__arrow, .splide__arrow');

          contentTeaserSlides.forEach(contentTeaser => {
            contentTeaser.classList.add('teaser-fade-in');
          });

          if (teaserArrows) {
            teaserArrows.forEach(arrow => {
              arrow.classList.add('teaser-fade-in');
            });
          }
        }
      }
    });

  addWindowResizeListener();
};

if (document.querySelector('.js-swa-header')) {
  init();

  // Show outline when navigating by TAB
  window.addEventListener('keyup', renderOutline);

  // Show the access box when tabbing
  const header = document.querySelector('header');
  header && header.addEventListener('keyup', showHideSkipLinks);
}
